import React from 'react';
import { Flex, HStack, Spinner, Text } from '@cad-arc';
export function LoadingIndicator(): React.ReactElement {
    return (
        <Flex h="100%" w="100%" justifyContent="center" alignItems="center">
            <HStack>
                <Spinner />
                <Text variant="headingSm">Loading</Text>
            </HStack>
        </Flex>
    );
}
